import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.items.length ? _c('div', {
    class: [_vm.$style.wrapper, _vm.$style.sortWrapper, _vm.showSort && _vm.$style.sortOpened],
    attrs: {
      "id": "sort"
    }
  }, [_c('div', {
    class: _vm.$style.inner,
    on: {
      "click": _vm.handleSortToggle
    }
  }, [_c('SButton', {
    class: _vm.$style.iconWrapper,
    attrs: {
      "equal": "",
      "size": "large",
      "theme": "ghost",
      "only-visual": ""
    }
  }, [_c('SIcon', {
    class: _vm.$style.icon,
    attrs: {
      "icon": "i-filter",
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.text
  }, [_vm._v("\n      Сортировать: "), _c('span', {
    class: _vm.$style.accent
  }, [_vm._v(_vm._s(_vm.current.label))])]), _vm._v(" "), _c('SIcon', {
    class: _vm.$style.sortIcon,
    attrs: {
      "icon": "i-chevronDown",
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('ContextPopover', {
    attrs: {
      "attach": "#sort",
      "content-class": _vm.$style.sort
    },
    model: {
      value: _vm.showSort,
      callback: function callback($$v) {
        _vm.showSort = $$v;
      },
      expression: "showSort"
    }
  }, [_c('VList', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('VListItem', {
      key: "".concat(item.value, "-").concat(index),
      attrs: {
        "disabled": item.value === _vm.current.value
      },
      on: {
        "click": function click($event) {
          return _vm.handleSortChange(item);
        }
      }
    }, [_c('VListItemTitle', [_vm._v(_vm._s(item.label))])], 1);
  }), 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };